import { tryParseJson } from './utils/objects';
import storage from './storage';

const SERVER_INFO_KEY = 'server_info';

export const getLoginInfoFromStorage = (servers, useDefault = false) => {
  try {
    const defaultBody = useDefault ? {
      mail: storage.getItem('mail'),
      password: storage.getItem('password'),
    } : {};
    const ret = tryParseJson(storage.getItem(SERVER_INFO_KEY), {});
    for (const s of servers ?? []) {
      ret[s] = ret[s] ?? { ...defaultBody };
    }
    return ret;
  } catch (e) {
    console.error(e);
    return {};
  }
};

export const putLoginInfoToStorage = (server, body) => {
  const currentData = tryParseJson(storage.getItem(SERVER_INFO_KEY), {});
  currentData[server] = body;
  storage.setItem(SERVER_INFO_KEY, JSON.stringify(currentData));
};